// @ts-nocheck
/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class ApiRegisterPushNotificationTokenRequest {
    'device_id': string;
    'token': string;
    /**
    * Optional profile_id
    */
    'profile_id'?: string;
    /**
    * Optional platform (ios, android, web)
    */
    'platform'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "device_id",
            "baseName": "device_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "token",
            "baseName": "token",
            "type": "string",
            "format": ""
        },
        {
            "name": "profile_id",
            "baseName": "profile_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "platform",
            "baseName": "platform",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return ApiRegisterPushNotificationTokenRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

